import { createPinia } from 'pinia';
import { createApp, defineAsyncComponent, ref } from 'vue';

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS
import CookiesBar from './plugins/cookies-bar/index.js';
import Modals from './plugins/modals/index.js';
import Tabs from './plugins/tabs/index.js';
import ScrollTo from './plugins/scroll-to/index.js';
import SiteDrawer from './plugins/site-drawer/index.js';
import Currency from './plugins/currency/index.js';
import PageLoader from './plugins/page-loader/index.js';

/////////////////////////////////////////////////////////////////////////////////////////////////// SHOP


/////////////////////////////////////////////////////////////////////////////////////////////////// APP
import Animations from "./animations.js";
import "bootstrap/js/dist/collapse.js";
// import { viewportSize } from './imports/utils';

createApp({
    mixins: [Animations],
    setup() {
        if (process.env.NODE_ENV === 'production') console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');

        ///////////////////////////////////////////////////////////////////////////// scrollTop
        const scrollTop = ref(0);
        const onScroll = () => {
            scrollTop.value = window.scrollY;
        }
        window.addEventListener("scroll", onScroll, { passive: true });

        ///////////////////////////////////////////////////////////////////////////// return
        return {
            assets: `/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist`,
            shopUrls: window.Laravel.shop,
            scrollTop,
        }
    },
    // created() {
    //     // window.addEventListener("resize", this.onResize, { passive: true });
    //     // if (this.isDevice) document.querySelector("html").classList.add("device");
    // },
    // destroyed() {
    //     // window.removeEventListener("resize", this.onResize)
    // }
})
    .component('NewsletterInput', defineAsyncComponent(() => import('./components/newsletter-input/index.vue')))
    .component('BgImage', defineAsyncComponent(() => import('./components/bg-image/index.vue')))
    .component('BgVideo', defineAsyncComponent(() => import('./components/bg-video/index.vue')))
    .component('CircleText', defineAsyncComponent(() => import('./components/circle-text/index.vue')))
    .component('RequestFormCraft', defineAsyncComponent(() => import('./request-form-craft.vue')))
    .component('RequestFormAmulets', defineAsyncComponent(() => import('./request-form-amulets.vue')))
    .component('ProductsList', defineAsyncComponent(() => import('./shop/products/products-list.vue')))
    .component('ProductInner', defineAsyncComponent(() => import('./shop/products/product-inner.vue')))
    .component('TheCart', defineAsyncComponent(() => import('./shop/cart/the-cart.vue')))
    .component('CheckoutDelivery', defineAsyncComponent(() => import('./shop/checkout/checkout-delivery.vue')))
    .use(createPinia())
    .use(CookiesBar)
    .use(Modals)
    .use(Tabs)
    .use(PageLoader)
    .use(ScrollTo, {
        // debug: true,
        headerHeight: 155,
        menuSelector: '.collections-menu'
    })
    .use(SiteDrawer)
    .use(Currency)
    .mount('#app')